module.exports = __webpack_public_path__ + "img/water-drop-gray.e6a039d1.svg";